import React from "react";
import { useTranslation } from "react-i18next";

import { useLinkPayCookies } from "../../../../common/hooks/useLinkPayCookies";
import "./ViewOnlyModeAlert.scss";

interface ViewOnlyModeAlertProps {}

const ViewOnlyModeAlert: React.FC<ViewOnlyModeAlertProps> = () => {
	const { t } = useTranslation();
	const { accessToken, uid, hasDefaultCard } = useLinkPayCookies();

	const getMessageKey = () => {
		if (!accessToken) {
			return "ViewOnlyModeAlert.noAccessToken";
		}
		if (!uid) {
			return "ViewOnlyModeAlert.noUid";
		}
		if (!hasDefaultCard) {
			return "ViewOnlyModeAlert.noDefaultCard";
		}

		return "ViewOnlyModeAlert.message";
	};

	return (
		<div className={`ViewOnlyModeAlert`}>
			<div className="ViewOnlyModeAlertContent">
				<div className="ViewOnlyModeAlertIcon">
					<span className="ViewOnlyModeAlertWarningNumber">!</span>
				</div>
				<div className="ViewOnlyModeAlertText">
					<div className="ViewOnlyModeAlertTitle">{t("ViewOnlyModeAlert.title")}</div>
					<div className="ViewOnlyModeAlertMessage">{t(getMessageKey())}</div>
				</div>
			</div>
		</div>
	);
};

export default ViewOnlyModeAlert;
